import * as React from 'react'
import { ReactElement } from 'react'
import TimeForm from '../../components/Form/Time/TimeForm'
import AddEntityForm from '../../components/Form/AddEntityForm'
import { TimeMutationDto, TimeOverviewDto } from '../../config/registrationConfig'
import { EntityFormPage } from '../../components/Form/Form'
import useAxios from '../../hooks/useAxios'
import { TimeAction } from '../../config/registration/timeConfig'

export default function AddTime(props: EntityFormPage): ReactElement {
    const axios = useAxios()
    return (
        <AddEntityForm<TimeOverviewDto, TimeMutationDto>
            {...props}
            form={TimeForm}
            addEntity={values => ({
                type: TimeAction.Add,
                payload: axios.post('/time', values),
            })}
            getResetValues={(initialValues: TimeMutationDto, values: TimeMutationDto) => ({
                ...initialValues,
                currency: values.currency,
                date: values.date,
                rate: values.rate,
                fileId: values.fileId,
                userId: values.userId,
            })}
        />
    )
}
